import React from "react";
import { Box } from "@chakra-ui/react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const ProjectCardSkeleton = () => {
	return (
		<Box className="w-full overflow-hidden">
			<Box className="rounded-lg bg-white">
				<div className="h-[300px] w-full">
					<Skeleton height={300} />
				</div>
				<Box className="p-6">
					<Box className="mb-6">
						<Skeleton
							height={30}
							width="70%"
							className="mb-2"
						/>
						<Skeleton
							height={20}
							width="50%"
						/>
					</Box>

					<Box className="mb-5">
						<Skeleton
							count={3}
							height={20}
							className="mb-2"
						/>
					</Box>

					<Box className="mb-5">
						{[1, 2, 3, 4, 5].map((item) => (
							<Skeleton
								key={item}
								height={20}
								className="mb-3"
							/>
						))}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default ProjectCardSkeleton;
